export default class BaseObject {
  constructor(data) {
    this.linked = false;
    this.id = data.name;
  }


  /**
   * function to parse the replied property Matrix
   * in one array of objects, all the columns will
   * be object properties.
   */
  static _createArrayWithObjects(reply) {
    let outputArray = [];
    for (let i = 0; i < reply.celldata.length; i++) {
      const translateObj = {}
      for (let data in reply.columns) {
        if (reply.columns.hasOwnProperty(data)) {
          let index = reply.columns[data];
          switch (data) {
            default:
              translateObj[data] = reply.celldata[i][index];
          }
        }
      }
      outputArray.push(translateObj);
    }
    return outputArray;
  }

  /**
   * function to rework all object properties to be lower case initial
   */
  static _toLowerCaseInitialProperty(objectArray) {
    let newObjArray = [];
    objectArray.forEach((e, index) => {
      // let tmp = {};
      // for (const [k, v] of Object.entries(e)) {
      //   const newK = k[0].toLowerCase() + k.substring(1, k.length);
      //   tmp[newK] = v;
      // }
      newObjArray.push(BaseObject._toLowerCaseObjectProperties(e));
    });
    return newObjArray;
  }


  static _toLowerCaseObjectProperties(object) {
    let tmp = {};
    for (let [k, v] of Object.entries(object)) {
      const newK = k[0].toLowerCase() + k.substring(1, k.length);
      if (typeof v === "object") {
        v = BaseObject._toLowerCaseObjectProperties(v);
      }
      tmp[newK] = v;
    }
    return tmp;
  }

  static _toLowerCaseObjectPropertiesAtFirstLevelWithOutLodash(object) {
    let tmp = {};
    for (let [k, v] of Object.entries(object)) {
      let newK = k;
      if (isNaN(k)) {
        newK = k[0].toLowerCase() + k.substring(1, k.length);
      }
      tmp[newK] = v;
    }
    return tmp;
  }

  static _toLowerCaseObjectPropertiesAtFirstLevel(object) {
    let tmp = {};
    for (let [k, v] of Object.entries(object)) {
      let newK;
      if (isNaN(k)) {
        newK = k[0].toLowerCase() + k.substring(1, k.length);
      } else {
        newK = "_" + k;
      }
      tmp[newK] = v;
    }
    return tmp;
  }
}
